var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslationQueueInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00049 0.625C3.39502 0.625 0.500488 3.54492 0.500488 7.125C0.500488 10.7305 3.39502 13.625 7.00049 13.625C10.5806 13.625 13.5005 10.7305 13.5005 7.125C13.5005 3.54492 10.5806 0.625 7.00049 0.625ZM7.00049 3.875C7.43213 3.875 7.81299 4.25586 7.81299 4.6875C7.81299 5.14453 7.43213 5.5 7.00049 5.5C6.54346 5.5 6.18799 5.14453 6.18799 4.6875C6.18799 4.25586 6.54346 3.875 7.00049 3.875ZM8.01611 10.375H5.98486C5.62939 10.375 5.37549 10.1211 5.37549 9.76562C5.37549 9.43555 5.62939 9.15625 5.98486 9.15625H6.39111V7.53125H6.18799C5.83252 7.53125 5.57861 7.27734 5.57861 6.92188C5.57861 6.5918 5.83252 6.3125 6.18799 6.3125H7.00049C7.33057 6.3125 7.60986 6.5918 7.60986 6.92188V9.15625H8.01611C8.34619 9.15625 8.62549 9.43555 8.62549 9.76562C8.62549 10.1211 8.34619 10.375 8.01611 10.375Z",
    fill: "#00A4E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslationQueueInfo);
export default __webpack_public_path__ + "static/media/translation-queue-info.740d546f3778296216f23ac6295106ea.svg";
export { ForwardRef as ReactComponent };